import React, { Component, Fragment } from 'react';
import __ from 'lodash';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import { CONFIG, CONFIG_API_BE, URL_AKM} from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import akmApi from '../../../../../apis/akmApi';
import eduprimeApi from '../../../../../apis/eduprimeApi';
import {Row, Col, Alert,Modal} from 'react-bootstrap';
import Select from 'react-select';


import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import Loader from '../../../../Loader';

import DropdownKelas from '../../masterDropDown/DropdownKelas';
import DropdownKelasParalel from '../../masterDropDown/DropdownKelasParalel';
import DropdownProvinsi from '../../masterDropDown/DropdownProvinsi';
import DropdownKota from '../../masterDropDown/DropdownKota';
import DropdownJadwalProfilCbt from '../../masterDropDown/DropdownJadwalProfilCbt';
import Dropdown from 'react-bootstrap/Dropdown'
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Paper,IconButton,Typography,Collapse,Box, Button, ButtonGroup} from '@material-ui/core';

class ListSekolahAkm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching : false,
            isOpenModalKelasParalel : false,
            isOpenModalSiswa : false,
            tahunAjaran : [],
            listProvinsi: [],
            listKota: [],
            sekolah: [],
            sekolahDummy: [],
            listKelas:[],
            listJadwal:[],
            listKelasSekolah: [],
            listKelasParalelSekolah: [],
            listSiswa:[],
            idProvinsi : null,
            idKota : null,
            idSekolah : null,
            namaSekolahSearch : null,
            taAktif : null,
            idKelas : null,
            idJadwal : null
        }
    }

    async componentDidMount() {
        await this.props.cekCookies();
        if(!__.isEmpty(this.props.account)) {
            this.fetchProvinsi();
            this.fetchKelas();
            // this.fetchTa();
        }
    }


    fetchKelas = async () => {
        this.setState({ isFetching: true });  
        const response = await akmApi.get(URL_AKM.KELAS_ALL)
        .catch(function(error){ this.setState({showAlert:true, resMessage: error});});
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                const data = {value : '', label: 'Pilih Kota...', id:'idKelas', selected: 'selected'}
                this.state.listKelas.push(data);
                response.data.data.map((val, i )=>{
                    const data = {value : val.idKelas, label: val.namaKelas, id:'idKelas'}
                    this.state.listKelas.push(data);
                })
            } else {
                this.setState({
                    listKelas: [], showAlert: true, resMessage: "Kelas " + response.data.errorSchema.errorMessage
                })
            }
            this.setState({ isFetching: false });  
        }
    }
 
    fetchProvinsi = async()=>{
        this.setState({isFetching:true})     
        const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_PROVINSI, {})
        if (respons) {
            if (!__.isEmpty(respons.data.list_provinsi)) {
                const dataProvinsi = {value : '', label: 'Pilih Provinsi...', id:'idProvinsi', selected: 'selected'}
                this.state.listProvinsi.push(dataProvinsi);
                respons.data.list_provinsi.map((val, i)=>{
                    const dataProvinsi = {value : val.ID_PROVINSI, label: val.NAMA_PROVINSI, id:'idProvinsi'}
                    this.state.listProvinsi.push(dataProvinsi);

                })
            }
        }
        this.setState({isFetching:false}) 
    }

    handleChangeSelect = async e => {
        const name = e.id;
        const id = e.value;
        this.setState({ 
            [e.id]: id,
            isFetching : true
        });
        console.clear();
        console.log(this.name);
        console.log(this.id);
        
        if(name == 'idProvinsi'){
            const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA+id, {})
            if (respons) {
                if (!__.isEmpty(respons.data.list_kab_kota)) {
                    this.setState({ listKota: [], idKabKota: null });
                    const data = {value : '', label: 'Pilih Kota...', id:'idKabKota', selected: 'selected'}
                    this.state.listKota.push(data);
                    respons.data.list_kab_kota.map((val, i )=>{
                        const data = {value : val.ID_KABUPATEN_KOTA, label: val.NAMA_KABUPATEN_KOTA, id:'idKabKota'}
                        this.state.listKota.push(data);
                    })
                }
            }
        }
        if(name == 'idKabKota'){
            const respons = await akmApi.get(URL_AKM.FETCH_JADWAL_CBT, {})
            if (respons) {
                if (!__.isEmpty(respons.data.data)) {
                    const data = {value : '', label: 'Pilih Jadwal...', id:'idJadwal', selected: 'selected'}
                    this.state.listJadwal.push(data);
                    respons.data.data.map((val, i )=>{
                        const data = {value : val.idJadwalProfilCbt, label: val.namaJadwalCbt, id:'idJadwal'}
                        this.state.listJadwal.push(data);
                    })
                }
            }
        }
        if(name === 'idKelas'){
            console.log(id);
            this.fetchFilterSekolah(id);
        }
        this.setState({ isFetching : false });
    };
    
    handleChangeKelas = async (e)=>{
        const id = e.target.value;
        this.setState({idKelas: id});
        this.fetchFilterSekolah(id);
    }

    handleJadwalOnchange = async (e) =>{
        this.setState({idJadwal: e.target.value})
    }

    fetchFilterSekolah = async (idKelas)=>{
        this.setState({isSearch:true})
        const idKab = this.state.idKabKota;
        const idJadwal = this.state.idJadwal;
        
        if(idKab != null && idKelas != null && idJadwal != null){
        const respons = await akmApi.get(URL_AKM.GET_SEKOLAH_BY_ID_KELAS_KABUPATENKOTA+idKab+'/'+idKelas, {})
            if (respons) {
                if (!__.isEmpty(respons.data.data)) {
                    this.setState({
                        sekolah: respons.data.data
                    })
                }
            }
        }

        this.setState({isSearch:false})
    }

    handleOnChangeNamaSekolah = async ()=>{
        const sekolahDummy = this.state.sekolah;
        if(this.state.sekolah != null){
            // this.setState({sekolah : []})
            this.state.sekolah.map((val,i) => {
               // console.log(val.namaSekolah)
            })
        }
    }

    handleOnchangeKelasSekolah = async(e)=>{
        this.setState({isSearch:true});
        const data ={
            'idKelas': e.target.value,
            'idSekolah': this.state.idSekolah
        }

        const response = await akmApi.post(URL_AKM.FETCH_KELAS_PARALEL_BY_ID_SEKOLAH_KELAS, {...data}).catch (function(error){ alert(error) })  
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({listKelasParalelSekolah: response.data.data})                    
            }           
        }
        this.setState({isSearch:false});
    }

    handleOnchangeKelasParalelSekolah = async(e)=>{
        this.setState({isSearch:true});
        const data ={
            'idKelasParalel' : e.target.value,
            'idSekolah': this.state.idSekolah
        }
        const response = await akmApi.post(URL_AKM.FETCH_SISWA_BY_ID_KELAS_PARALEL_AND_SEKOLAH, {...data}).catch (function(error){ alert(error) })  
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({listSiswa: response.data.data})                    
            }           
        }
        this.setState({isSearch:false});
    }


    render(){
        const {listProvinsi, idProvinsi, listKota, idKota, listJadwal, idJadwal, listKelas, idKelas} = this.state;
        return (
            <div className="wrapper">
            <LoaderModal isFetching={this.state.isFetching}/> 
            <Sidebar account={this.props.account}/>
            <div id="content" style={{paddingBottom: '50px'}}>
                <Navbar title="Reporting AKM sekolah"/>            
                {this.loadAlert()}
                <Row>
                    <Col sm={4}>
                        <Fragment>    
                            <Select 
                                options={listProvinsi}
                                onChange={this.handleChangeSelect}
                                placeholder ="Pilih Provinsi..."
                            />
                            <input
                                tabIndex={-1}
                                autoComplete="off"
                                style={{ opacity: 0, height: 0 }}
                                value={idProvinsi}
                                required
                            />
                        </Fragment>
                    </Col> 
                    <Col sm={4}>
                        <Fragment>    
                            <Select 
                                options={listKota}
                                onChange={this.handleChangeSelect}
                                placeholder ="Pilih Kabupaten / Kota..."
                            />
                            <input
                                tabIndex={-1}
                                autoComplete="off"
                                style={{ opacity: 0, height: 0 }}
                                value={idKota}
                                required
                            />
                        </Fragment> 
                    </Col>  
                    <Col sm={4}>
                        <Fragment>    
                            <Select 
                                options={listJadwal}
                                onChange={this.handleChangeSelect}
                                placeholder ="Pilih Jadwal..."
                            />
                            <input
                                tabIndex={-1}
                                autoComplete="off"
                                style={{ opacity: 0, height: 0 }}
                                value={idJadwal}
                                required
                            />
                        </Fragment> 
                    </Col> 
                </Row>   
                <Row>
                    <Col xs={12} md={4}>
                        {/* <div className="form-group">                                  
                            <select className="form-control" name="kelas" id="kelas" 
                                value={this.state.idKelas}
                                onChange={this.handleChangeKelas} >
                                <option value="">Pilih Kelas...</option>
                                <DropdownKelas kelas={this.state.listKelas}/>
                            </select>
                        </div> */}
                        <Fragment>    
                            <Select 
                                options={listKelas}
                                onChange={this.handleChangeSelect}
                                placeholder ="Pilih Kelas..."
                            />
                            <input
                                tabIndex={-1}
                                autoComplete="off"
                                style={{ opacity: 0, height: 0 }}
                                value={idKelas}
                                required
                            />
                        </Fragment> 
                    </Col>

                   
                </Row>  
 


                {/* <Row>
                    <Col xs={12} md={8}>
                        
                    </Col>
                    <Col xs={6} md={4}>
                        <Form.Group controlId="namaSekolah">
                            <Form.Control
                            type="text"
                            onChange={this.handleOnChangeNamaSekolah}
                            placeholder="Cari Sekolah.."
                            value={this.state.namaSekolahSearch} />
                        </Form.Group>
                    </Col>
                </Row>   */}
                {this.loading()}
                {this.renderModalKelasParalel()}
                {this.renderModalSiswa()}

                <Row>
                    <Col xs={12} md={12}>
                        {
                            this.state.sekolah != null &&
                            this.renderTableSekolah()
                        }
                    </Col>
                </Row>
            </div>
        </div>
        )
    }

    renderTableSekolah(){
        return(
            <table className="table table-sm table-striped table-hover">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Nama Sekolah</th>
                        <th>Report</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderChildSekolah()}
                </tbody>
            </table>
        )
    }

    renderChildSekolah(){
        if(!__.isEmpty(this.state.sekolah)){
            return this.state.sekolah.map((val,i) => {                
                return (
                    <tr key={i}>
                        <td>{i+1}</td>
                        <td>{val.namaSekolah}</td>
                        <td>
                            {/* <a href ={'/rptakm/'+  this.state.idJadwal+'/'+val.idSekolah+'/'+this.state.idKelas} target="_blank" className="btn btn-outline-danger">
                                <li className="fa fa-bar-chart"></li>
                            </a> */}
                            <Dropdown as={ButtonGroup}>
                                <button className="btn btn-success">Download</button>
                                <Dropdown.Toggle split variant="success" id="dropdown-split-basic" />

                                <Dropdown.Menu>
                                    <Dropdown.Item href ={'/rptakm?idJadwal='+  this.state.idJadwal+'&idSekolah='+val.idSekolah+'&idKelas='+this.state.idKelas+'&idKelasParalel='+null} target="_blank">Sekolah</Dropdown.Item>
                                    <Dropdown.Item onClick={() => this.handleModal(val.idSekolah, true, false)}> Kelas Paralel</Dropdown.Item>
                                    <Dropdown.Item onClick={() => this.handleModal(val.idSekolah, false, true)}>Siswa</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </td>
                    </tr>
                )
            })
        }
    }

    async handleModal(idSekolah, modalKelas, modalSiswa){        
        this.setState({
            isSearch:true,
            isOpenModalKelasParalel: modalKelas,
            isOpenModalSiswa : modalSiswa,
            idSekolah: idSekolah,
            listKelasParalelSekolah : []
        })     
        const respons = await akmApi.get(URL_AKM.GET_KELAS_BY_ID_SEKOLAH+idSekolah, {})
        if (respons) {
            if (!__.isEmpty(respons.data.data)) {
                this.setState({
                    listKelasSekolah: respons.data.data
                })
            }
        }
       
        this.setState({
            isSearch:false
        })
    }

    renderModalKelasParalel(){
        return(
            <Modal 
                show={this.state.isOpenModalKelasParalel}
                onHide={() => this.setState({ isOpenModalKelasParalel: false })}
                aria-labelledby="example-custom-modal-styling-title"
                size="lg" backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Kelas Paralel</Modal.Title>
                    {this.loading()}
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col xs={12}>
                            <div className="form-group">                                  
                                <select className="form-control" name="kelasSekolah" id="kelasSekolah" 
                                        onChange={this.handleOnchangeKelasSekolah}>
                                    <option value="">Pilih Kelas...</option>
                                    <DropdownKelas kelas={this.state.listKelasSekolah}/>
                                </select>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {this.loading()}
                            <TableContainer component={Paper}>
                                <Table aria-label="collapsible table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left">No</TableCell>
                                            <TableCell align="left">Kelas Paralel</TableCell>
                                            <TableCell align="left">Download</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.renderChildKelasParalel()}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }

    renderModalSiswa(){
        return(
            <Modal 
                show={this.state.isOpenModalSiswa}
                onHide={() => this.setState({ isOpenModalSiswa: false })}
                aria-labelledby="example-custom-modal-styling-title"
                size="lg" backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Kelas Paralel</Modal.Title>
                    {this.loading()}
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col xs={6}>
                            <div className="form-group">                                  
                                <select className="form-control" name="kelasSekolah" id="kelasSekolah" 
                                        onChange={this.handleOnchangeKelasSekolah}>
                                    <option value="">Pilih Kelas...</option>
                                    <DropdownKelas kelas={this.state.listKelasSekolah}/>
                                </select>
                            </div>
                        </Col>
                        <Col xs={6}>
                            <div className="form-group">                                  
                                <select className="form-control" name="kelasParalelSekolah" id="kelasParalelSekolah" 
                                        onChange={this.handleOnchangeKelasParalelSekolah}>
                                    <option value="">Pilih Kelas Paralel...</option>
                                    <DropdownKelasParalel kelasParalel={this.state.listKelasParalelSekolah}/>
                                </select>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {this.loading()}
                            <TableContainer component={Paper}>
                                <Table aria-label="collapsible table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left">No</TableCell>
                                            <TableCell align="left">Nama Siswa</TableCell>
                                            <TableCell align="left">Download</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.renderChildListSiswa()}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }


    renderChildKelasParalel(){
        if(!__.isEmpty(this.state.listKelasParalelSekolah)){
            return(
                this.state.listKelasParalelSekolah.map((val, i)=>
                    <TableRow key={i}>
                        <TableCell>{i+1}</TableCell>
                        <TableCell>{val.namaKelasParalel}</TableCell>
                        <TableCell>
                            <a href ={'/rptakm?idJadwal='+  this.state.idJadwal+'&idSekolah='+val.idSekolah+'&idKelas='+this.state.idKelas+'&idKelasParalel='+val.idKelasParalel} target="_blank" className="btn btn-outline-success" title={'Download Kelas => '+val.namaKelasParalel} > <li className="fa fa-print"></li></a>
                        </TableCell>
                    </TableRow>
                )
            )
        }
    }

    renderChildListSiswa(){
        if(!__.isEmpty(this.state.listSiswa)){
            return(
                this.state.listSiswa.map((val, i)=>
                    <TableRow key={i} style={{"padding":"0px"}}>
                        <TableCell style={{"padding":"0px"}}>{i+1}</TableCell>
                        <TableCell style={{"padding":"0px"}}>{val.namaSiswa}</TableCell>
                        <TableCell style={{"padding":"0px"}}>
                            <a href={
                                    'rptakmsiswa?idSiswa='+val.idSiswa+'&idJadwal='+this.state.idJadwal+'&idSekolah='+val.idSekolah+
                                    '&idKelas='+val.idKelas+'&idKelasParalel='+val.idKelasParalel
                                    } className="btn btn-outline-success" title={'Download Reportnya => '+val.namaSiswa} target='_blank'>
                                    <li className="fa fa-print"></li
                            ></a>
                        </TableCell>
                    </TableRow>
                )
            )
        }
    }

    loading = () =>{
        if(this.state.isSearch){
            return(
                <Loader />
            )
        }
    }


    loadAlert = () => {
        const {alertShow } = this.state;
        if (alertShow) {
          return (
            <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        }
    }

}
const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(ListSekolahAkm);
